import api from '../../../services/apiConfig';

export interface SalesChessClient {
    clientId: number;
    clientName: string;
    city: string;
    state: string;
    totalSales: number;
}

export interface SalesChessData {
    clients: SalesChessClient[];
    months: string[];
    salesData: Record<string, Record<string, {
        totalSales: number;
        orderCount: number;
    }>>;
    monthlyTotals: Record<string, {
        totalSales: number;
        orderCount: number
    }>;
    pagination: {
        currentPage: number;
        totalPages: number;
        totalItems: number;
    };
    cached?: boolean;
    cachedAt?: string;
}

export interface SalesChessParams {
    carteiraId?: string;
    page?: number;
    limit?: number;
    search?: string;
    minTotal?: number;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    dataI?: string;
    dataF?: string;
    periodo?: '12meses' | 'anual' | 'mensal' | 'semanal' | 'custom';
    refresh?: boolean;
}

export const getSalesChess = async (params: SalesChessParams): Promise<SalesChessData> => {
    try {
        const response = await api.get<SalesChessData>('/sales-chess', { params });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar xadrez de vendas:', error);
        throw error;
    }
};